import { useEffect } from 'react'

export default function useFreezeBodyScroll<
  T extends React.RefObject<HTMLInputElement>,
>(freezeState: boolean, ref: T) {
  useEffect(() => {
    if (ref.current === null) return
    if (freezeState) {
      if (ref?.current?.getBoundingClientRect()?.top < 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = freezeState ? 'hidden' : 'auto'
    document.body.style.paddingRight = freezeState ? `${scrollbarWidth}px` : '0'

    return () => {
      document.body.style.overflow = "auto"
      document.body.style.paddingRight = "0"
    }

  }, [freezeState, ref])
}
